import { TCommonApplicantParams } from '@/stores';

import { TValues } from './define-assignment.config';

export const formatDataToSubmit = (
	values: TValues,
	rowKeySelection: number[],
	removeIds: number[],
	id?: number
) => {
	return {
		id,
		type: values.type,
		franchiseId: Number(values.franchiseId) || undefined,
		programId: Number(values.programId) || undefined,
		startDate: values.startDate || '',
		endDate: values.endDate || '',
		memo: values.memo || '',
		applicantIds: rowKeySelection || [],
		removeIds: removeIds || [],
		requestApplicant: Number(values.requestApplicant) || undefined,
		publicFranchiseId: Number(values.publicFranchiseId) || undefined,
	};
};

export const shouldResetRowSelection = (params: TCommonApplicantParams) => {
	const excludedKeys = ['page', 'sortSql', 'fullName', 'assignmentPossibility'];
	return (
		Object.keys(params).length > 0 && !excludedKeys.some((key) => key in params)
	);
};
